import {
  SettingParamTypes,
  WorkflowNodeData,
  WorkflowNodeTypes,
} from "@/types/node";
import {Node} from "@xyflow/react";

export const jumpNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.JUMP,
  data: {
    type: WorkflowNodeTypes.JUMP,
    settingsTitle: "Jump To",
    description: "This is the jump node",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "Jump To Settings",
        description: "",
        params: [
          {
            label: "Branch or Step",
            type: SettingParamTypes.NODE_SELECT,
            key: "jump_to_step",
            value: "",
            placeholder: "Select",
          },
        ],
      },
    ],
  },
  position: {x: 0, y: 0},
};
